<template>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>

      <v-row class="pa-2 mb-4">
        <v-col cols="12" md="2">
          <v-select
            v-model="searchParams.region"
            :hint="lang($store, 'sap/listings.global.filter.hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="searchParams.period"
            :items="periodItems"
            prepend-icon="mdi-calendar"
            single-line
            :hint="lang($store, 'sap/listings.global.filter.hints.period')"
            persistent-hint
          ></v-select>
        </v-col>

        <template v-if="searchParams.period===PERIODS.CUSTOM_PERIOD">
          <v-col cols="12" md="2" offset-md="1">
            <v-menu
              v-model="menuFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fromDateFormatted"
                  @input="changeDate('from', $event)"
                  :label="lang($store, 'sap/listings.global.filter.hints.date_from')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="searchParams.from" no-title
                            :first-day-of-week="1"
                            :locale="getCurrentLocale()"
                            @input="menuFrom = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              v-model="menuTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="toDateFormatted"
                  @input="changeDate('to', $event)"
                  :label="lang($store, 'sap/listings.global.filter.hints.date_to')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="searchParams.to" no-title
                            :first-day-of-week="1"
                             :locale="getCurrentLocale()"
                            @input="menuTo = false"></v-date-picker>
            </v-menu>
          </v-col>
        </template>
      </v-row>
      <download-file-button
        v-if="hasReport && account.role === MANAGER_TOP"
        :use-download-report-users="true"
        style="position: absolute; top: 5px; right: 5px"
        @click="$emit('download-excel')"
      />
    </v-card>
</template>

<script>
import moment from 'moment';
/* constants */
import regionsFilter from '@/mixins/filters/regionsFilter';
import periodFilter from '@/mixins/filters/periodFilter';
import { DATE_ISO } from '@/constants/dates';
import { MANAGER_TOP } from '@/constants/roles';
import * as PERIODS from '../../constants/time_periods';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';
/* components */
import DownloadFileButton from '../minialerts/DownloadFileButton.vue';

export default {
  name: 'FilterHooverStats',
  mixins: [isComponentLoading, regionsFilter, periodFilter],
  components: {
    DownloadFileButton,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search_contact: '',
        search_cleaner: '',
      }),
    },
    hasReport: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      MANAGER_TOP,
      useNullableOrderStatus: false,
      searchParams: {},
      menuFrom: false,
      menuTo: false,
      PERIODS,
    };
  },
  mounted() {
    this.searchParams = {
      from: moment()
        // .subtract(7, 'days')
        .startOf('month')
        .format(DATE_ISO),
      to: moment()
        .startOf('day')
        .add(1, 'days')
        .format(DATE_ISO),
      period: PERIODS.THIS_YEAR,
      region: null,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
    toDateFormatted() {
      return this.formatDate(this.searchParams.to);
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
    getCurrentLocale() {
      return window.localStorage.language;
    }
  },
};
</script>

<style scoped>
</style>
